export const siteInfo = {
  name: "爆料专区",
  tagline: "年度盘点 · 大事件回顾 · 旧瓜复盘",
  slogan: "把散落的娱乐情报，整理成一条看得懂的时间线",
  intro:
    "爆料专区是一个专注娱乐事件脉络整理的中文内容站。我们不追逐一时的热度，而是把已经公开的事件信息收集起来，按主题与时间归档，还原来龙去脉、标注后续进展，让一件旧事也能被重新读懂。",
  email: "contact@baoliao-archive.com",
  since: "2019",
  location: "线上编辑部",
};

export const categories = [
  { id: "love", name: "情感八卦", icon: "ri-heart-3-line", desc: "同框、曝光、回应与后续进展" },
  { id: "variety", name: "综艺风波", icon: "ri-mic-line", desc: "录制现场、剪辑争议与节目走向" },
  { id: "screen", name: "影视争议", icon: "ri-film-line", desc: "选角、换角、档期与口碑波动" },
  { id: "music", name: "乐坛动态", icon: "ri-music-2-line", desc: "专辑延期、演出变动与市场反馈" },
  { id: "brand", name: "商业代言", icon: "ri-store-3-line", desc: "代言更替、物料调整与品牌策略" },
  { id: "idol", name: "偶像生态", icon: "ri-star-smile-line", desc: "出道、团体变动与粉丝讨论" },
];

export const siteStats = [
  { value: "1,286", label: "整理事件" },
  { value: "8 年", label: "覆盖跨度" },
  { value: "42", label: "复盘专题" },
  { value: "5,600万", label: "累计阅读" },
];

export const contentPrinciples = [
  {
    title: "只依据已公开信息",
    desc: "站内所有内容均来自公开传播的报道与声明，不采用来路不明的私信爆料，也不做未经核实的推测性结论。",
  },
  {
    title: "统一匿名化叙述",
    desc: "涉及个人时统一使用某艺人、某节目、某剧组等表述，把重点放在事件本身，而不是指向具体个人。",
  },
  {
    title: "时间线优先于观点",
    desc: "每篇档案都会列出关键节点，先讲清楚什么时候发生了什么，再呈现各方的公开回应，让读者自行判断。",
  },
  {
    title: "持续标注后续进展",
    desc: "事件不会在声明发布时就结束。我们会跟踪后续处理结果，补充到原档案中，避免旧信息误导新读者。",
  },
];

export const milestones = [
  { year: "2019", title: "档案库起步", desc: "从零散的热点整理开始，建立了以主题分类归档的基础规则。" },
  { year: "2021", title: "引入时间线体系", desc: "为每篇档案补充节点式时间线，让事件的先后顺序一目了然。" },
  { year: "2023", title: "年度盘点栏目上线", desc: "开始按年度推出大盘点，把全年重要事件串成一条完整脉络。" },
  { year: "2025", title: "复盘主题化", desc: "推出旧瓜复盘专题，按主题横向串联不同年份的相似事件。" },
];

export const readerVoices = [
  {
    name: "阿澈",
    role: "追更六年",
    text: "最难得的是不站队。同一件事的双方说法都会列出来，看完自己就能理清楚当年到底发生了什么。",
  },
  {
    name: "小满",
    role: "补课型读者",
    text: "以前刷到旧话题总是一头雾水，现在直接搜关键词就能看到完整时间线，省了翻旧帖的功夫。",
  },
  {
    name: "老周",
    role: "内容从业者",
    text: "作为同行，我很认可它的克制。没有夸张标题，信息密度高，引用也标得清清楚楚。",
  },
  {
    name: "橙子",
    role: "通勤读者",
    text: "每天路上读一篇档案刚刚好，长度合适，读完还能顺手看看相关推荐，越看越上头。",
  },
  {
    name: "林可",
    role: "新入坑读者",
    text: "我是被朋友安利的，从旧瓜复盘开始补课，一个下午就把前几年没看懂的事串明白了。",
  },
  {
    name: "子游",
    role: "深度读者",
    text: "喜欢它把事件放在行业背景里讲，不只是八卦。看多了会发现很多风波背后其实是同一套逻辑。",
  },
];

export const faqItems = [
  {
    q: "爆料专区的内容来源可靠吗？",
    a: "所有档案只整理已经公开传播的报道、声明与官方回应，并在文中标注了关键节点的时间。我们不使用无法溯源的私信截图，也不会把推测当作事实呈现。若后续信息有更新，会补充到原档案中。",
  },
  {
    q: "为什么文章中总是用某艺人、某节目这样的说法？",
    a: "这是本站的统一叙述规范。我们希望通过匿名化处理，把读者注意力引导到事件规律与行业现象上，而不是指向具体的个人，也尽量避免给当事人带来额外的打扰。",
  },
  {
    q: "年度盘点和旧瓜复盘有什么区别？",
    a: "年度盘点侧重时间维度，把某一年的重要事件按发生顺序整理出来；旧瓜复盘侧重主题维度，会把不同年份里性质相似、容易混淆的事件放在一起对比，帮助你区分来龙去脉。",
  },
  {
    q: "档案中的信息会一直不变吗？",
    a: "不会。娱乐事件的后续往往还有声明、澄清或处理结果，我们会持续跟进并更新到对应档案的末尾，同时在时间线中标注新增节点，方便老读者回看时发现变化。",
  },
  {
    q: "可以对某个事件提交补充线索吗？",
    a: "可以。你可以通过页面底部的读者反馈表提交线索或勘误，请尽量附上公开来源。我们会核实后再决定是否采纳，并会在档案中注明补充来源。",
  },
  {
    q: "本站的内容会涉及个人隐私吗？",
    a: "不会。涉及私人生活、未经证实的情感传闻或未成年人信息的内容，本站不会收录。我们关注的是公开事件中的公开言行，以及由此引发的行业讨论。",
  },
];

export const heroImage =
  "https://readdy.ai/api/search-image?query=Dramatic%20abstract%20editorial%20backdrop%20of%20glowing%20stage%20spotlights%20and%20blurred%20concert%20crowd%20silhouettes%20in%20deep%20crimson%20and%20warm%20charcoal%20tones%2C%20film%20grain%20texture%2C%20moody%20cinematic%20atmosphere%2C%20no%20text%2C%20no%20faces%2C%20high%20contrast%20wide%20banner%20composition&width=1600&height=900&seq=baoliao-hero-2026&orientation=landscape";

export const aboutImage =
  "https://readdy.ai/api/search-image?query=Warm%20editorial%20desk%20flat%20lay%20with%20vintage%20typewriter%2C%20stacked%20archive%20folders%2C%20magnifying%20glass%20and%20dried%20flowers%20under%20soft%20daylight%2C%20cream%20paper%20tones%20with%20deep%20red%20accents%2C%20minimalist%20magazine%20styling%2C%20top%20down%20architectural%20photography%2C%20no%20text&width=1200&height=800&seq=baoliao-about-2026&orientation=landscape";